<template>
    <div :class="{'has-logo':showLogo}" >
        <!-- <logo v-if="showLogo" :collapse="isCollapse" /> -->
        <el-scrollbar :class="settings.sideTheme" wrap-class="scrollbar-wrapper">
            <el-menu
                :default-active="activeMenu"
                :collapse="false"
                :unique-opened="true"
                :active-text-color="settings.theme"
                :collapse-transition="false"
                mode="vertical"
            >
                <sidebar-item
                    v-for="(route, index) in sidebarRouters"
                    :key="route.path  + index"
                    :item="route"
                    :base-path="route.path"
                />
            </el-menu>
        </el-scrollbar>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import Logo from "./Logo";
import SidebarItem from "./SidebarItem";
import variables from "@/assets/styles/variables.scss";

export default {
    components: { SidebarItem, Logo },
    computed: {
        ...mapState(["settings"]),
        ...mapGetters(["sidebarRouters", "sidebar"]),
        // ...mapGetters(["sidebar"]),
        activeMenu() {
            const route = this.$route;
            const { meta, path } = route;
            // if set path, the sidebar will highlight the path you set
            if (meta.activeMenu) {
                return meta.activeMenu;
            }
            return path;
        },
        showLogo() {
            return this.$store.state.settings.sidebarLogo;
        },
        variables() {
            return variables;
        },
        isCollapse() {
            return !this.sidebar.opened;
        }
    },
    data(){
        return {
            // sidebarRouters:[{"name":"Management","path":"/management","hidden":false,
            // "redirect":"noRedirect","component":"Layout","alwaysShow":true,
            // "meta":{"title":"应用管理","icon":"client","noCache":false},
            // "children":[{"name":"Management","path":"management",
            // "hidden":false,"component":"store/management",
            
            // "meta":{"title":"应用管理","icon":"list","noCache":false}},
            // {"name":"AppInfo","path":"appInfo","hidden":true,
            // "component":"store/appInfo","meta":{"title":"应用","icon":"component","noCache":false}}]}]
           }
    },
    mounted(){
    
    }
};
</script>
